import { type AmbitoDTO } from '@framework/api-client/api/inquiries/schemas/ambitoDTO.ts';
import {
  TreeSelectInput,
  type TreeSelectInputProps,
} from '@framework/ui/components/input/TreeSelectInput.tsx';
import { useScopesData } from '../useScopesData.ts';

export interface ICommonScopeTreeSelectInputProps
  extends Omit<TreeSelectInputProps, 'treeData' | 'loading'> {
  data?: AmbitoDTO[] | null;
  isLoading: boolean;
}

/**
 * Input per la selezione di un ambito.
 */
export function CommonScopeTreeSelectInput(
  props: ICommonScopeTreeSelectInputProps,
) {
  const { data, isLoading, ...otherProps } = props;

  const treeDataScopes = useScopesData(data);

  return (
    <TreeSelectInput
      style={{ width: '100%' }}
      dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
      treeDefaultExpandAll
      {...otherProps}
      treeData={treeDataScopes}
      loading={isLoading}
    />
  );
}
